import { IJoinInitRequest } from '@lib/types';
import { JoinInitInfo } from '../contracts';
import axios from 'axios';
import { createAxiosConfig } from '../mockHelper';
import LogCannon from '@ace-clublabs/log-cannon';
import CookieHelper from '../../utils/cookieHelper';

export const JoinInitInfoApi =
  (endpoint: string): JoinInitInfo =>
  async ({ zipcode, couponcode, campaigncode, flow, empId }: IJoinInitRequest) => {
    const scenario = CookieHelper.getCookie('scenario');
    try {
      const response = await axios.post(
        endpoint,
        { zipcode, couponcode, campaigncode, flow, empId },
        createAxiosConfig(scenario, endpoint)
      );
      sessionStorage.setItem('x-aws-region', response.headers['x-aws-region']!);
      LogCannon.blast('GetNewMembershipInfoApi success');
      return Promise.resolve(response?.data);
    } catch (e) {
      return Promise.reject({ error: e });
    }
  };
